import {
  Box,
  Checkbox,
  FormHelperText,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { DrawerCheckout } from "../../../../components/AtomicDesign/Molecules";
import { colors } from "../../../../theme/colors";
import { pink } from "@mui/material/colors";
import { useBRLmoney } from "../../../../hooks/useBRLmoney";
import useCart from "../../../../hooks/context/useCart";
import DeleteIcon from "@mui/icons-material/Delete";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";

interface Props {
  selectedProducts: CartXProduct[];
  selectOrRemove: (cart: CartXProduct) => void;
  addToCart: (productID: number, quantity: number) => void;
  removeFromCart: (productID: number, quantity: number) => void;
  setStep: VoidFunction;
  step: number;
  setSelectedAddressID: (addressID: number) => void;
  selectedAddressID: number;
  setSelectedFrete: (data: { freteType: string; value: string }) => void;
  selectedFrete: { freteType: string; value: string };
}

export function CartStep({
  selectedProducts,
  selectOrRemove,
  addToCart,
  setStep,
  removeFromCart,
  step,
  setSelectedAddressID,
  selectedAddressID,
  setSelectedFrete,
  selectedFrete,
}: Props) {
  const { isMobile, isSmalldesktop } = useBreakpoints();
  const { cartDataMemo } = useCart();
  const data = cartDataMemo[0];
  const { BRLmoney } = useBRLmoney();

  return (
    <>
      <Box display={"flex"} width={"100%"} gap={1} mt={2}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={1}
          minWidth={"100%"}
          justifyContent={"flex-start"}
          alignItems={"center"}
        >
          {data?.cartXProduct?.length > 0 ? (
            data?.cartXProduct?.map((item, index) => (
              <Box
                key={index}
                display={"flex"}
                flex={1}
                width={"100%"}
                alignItems={"flex-start"}
                flexDirection={"column"}
                sx={
                  selectedProducts?.find(
                    (selectedPRD) =>
                      selectedPRD?.product?.id === item?.product?.id
                  )
                    ? {
                        borderRadius: 3,
                        background: colors.purpleAlpha[300],
                      }
                    : { border: "1px solid white" }
                }
              >
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  width={"100%"}
                  flexWrap={isSmalldesktop ? "wrap" : "nowrap"}
                >
                  <Checkbox
                    onChange={() => selectOrRemove(item)}
                    disabled={item?.quantity > item?.product?.stock}
                    sx={{
                      mr: 2,
                      mt: isSmalldesktop ? -7 : 0,
                      ml: isSmalldesktop ? -5 : 0,
                    }}
                    checked={
                      selectedProducts?.find(
                        (selectedPRD) =>
                          selectedPRD?.product?.id === item?.product?.id
                      )
                        ? true
                        : false
                    }
                  />
                  <Box
                    width={150}
                    minHeight={150}
                    display={"flex"}
                    alignItems={"center"}
                    flexWrap={"wrap"}
                  >
                    <Box display={"flex"} alignItems={"center"}>
                      <img
                        src={item?.product?.productsImages[0]?.code}
                        style={{
                          objectFit: "contain",
                          width: isMobile ? 150 : 150,
                          height: isMobile ? 150 : 150,
                          borderRadius: 5,
                        }}
                        alt={item?.product?.name}
                      />
                      {isSmalldesktop && (
                        <IconButton
                          sx={{
                            bgcolor: pink[500],
                            "&:hover": { bgcolor: pink[300] },
                            color: "white",
                            mr: 0.5,
                            height: 40,
                          }}
                          disabled={
                            selectedProducts?.find(
                              (selectedPRD) =>
                                selectedPRD?.product?.id === item?.product?.id
                            )
                              ? true
                              : false
                          }
                          onClick={() =>
                            removeFromCart(item?.product?.id, item?.quantity)
                          }
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Box>

                    {isSmalldesktop && (
                      <Typography
                        mb={3}
                        textOverflow={"ellipsis"}
                        textAlign={"center"}
                        maxHeight={isMobile ? 50 : 80}
                        color={colors.purple[500]}
                      >
                        {item?.product?.name}
                      </Typography>
                    )}
                  </Box>

                  <Box
                    display={"flex"}
                    width={"100%"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    flexWrap={isSmalldesktop ? "wrap" : "nowrap"}
                    gap={3}
                  >
                    {!isSmalldesktop && (
                      <Typography
                        overflow={"hidden"}
                        ml={1}
                        width={"50%"}
                        textOverflow={"ellipsis"}
                        textAlign={"center"}
                        maxHeight={isMobile ? 50 : 80}
                        color={colors.purple[500]}
                      >
                        {item?.product?.name}
                      </Typography>
                    )}

                    <Box width={200}>
                      <Typography
                        textAlign={"center"}
                        width={"100%"}
                        fontSize={14}
                        color={colors.purple[500]}
                      >
                        Preço unitário
                      </Typography>
                      {item?.product?.discountPrice > 0 ? (
                        <Box display={"flex"} flexWrap={"wrap"} gap={1}>
                          <Typography
                            sx={{
                              fontSize: "20px",
                              fontWeight: 700,
                              textAlign: "left",
                              color: colors.green[400],
                            }}
                          >
                            {BRLmoney(item?.product?.discountPrice)}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "15px",
                              fontWeight: 500,
                              textAlign: "left",
                              color: colors.textGrey[500],
                              textDecoration: "line-through",
                            }}
                          >
                            {BRLmoney(item?.product?.price)}
                          </Typography>
                        </Box>
                      ) : (
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: 500,
                            textAlign: "left",
                            color: colors.textGrey[500],
                          }}
                        >
                          {BRLmoney(item?.product?.price)}
                        </Typography>
                      )}
                    </Box>
                    <Box
                      display={"flex"}
                      gap={2}
                      width={"50%"}
                      justifyContent={"center"}
                    >
                      <Box
                        display={"flex"}
                        flexDirection={"column"}
                        alignItems={"center"}
                        justifyContent={"center"}
                      >
                        <Typography
                          textAlign={"center"}
                          width={"100%"}
                          fontSize={14}
                          fontWeight={500}
                          color={colors.purple[500]}
                        >
                          Quantidade
                        </Typography>
                        <Box>
                          {item?.product.stock === 0 ? (
                            <Typography
                              sx={{
                                fontSize: isMobile ? 12 : "16px",
                                fontWeight: 700,
                                textAlign: "left",
                                color: colors.red[400],
                                wordBreak: "break-word",
                              }}
                            >
                              Esgotado
                            </Typography>
                          ) : (
                            <>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                disabled={
                                  selectedProducts?.find(
                                    (selectedPRD) =>
                                      selectedPRD?.product?.id ===
                                      item?.product?.id
                                  )
                                    ? true
                                    : false
                                }
                                defaultValue={item?.quantity}
                                defaultChecked
                                onChange={(e) =>
                                  addToCart(
                                    item?.product?.id,
                                    Number(e.target.value)
                                  )
                                }
                                sx={{ width: 70, height: 40 }}
                              >
                                {Array.from(
                                  {
                                    length: item?.product?.stock,
                                  },
                                  (_v, i) => i
                                ).map((qtd, index) => {
                                  const removeZero = qtd + 1;
                                  return (
                                    <MenuItem value={removeZero} key={index}>
                                      {removeZero}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              {item?.quantity > item?.product?.stock && (
                                <FormHelperText
                                  error
                                  sx={{ textAlign: "center" }}
                                >
                                  Nós não temos mais a quantidade anterior
                                  escolhida ({item?.quantity}).
                                </FormHelperText>
                              )}
                            </>
                          )}
                        </Box>
                      </Box>
                    </Box>
                    {!isSmalldesktop && (
                      <IconButton
                        sx={{
                          bgcolor: pink[500],
                          "&:hover": { bgcolor: pink[300] },
                          color: "white",
                          mr: 0.5,
                        }}
                        disabled={
                          selectedProducts?.find(
                            (selectedPRD) =>
                              selectedPRD?.product?.id === item?.product?.id
                          )
                            ? true
                            : false
                        }
                        onClick={() =>
                          removeFromCart(item?.product?.id, item?.quantity)
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}

                    <Box width={200}>
                      <Typography
                        textAlign={"center"}
                        width={"100%"}
                        fontSize={14}
                        color={colors.purple[500]}
                      >
                        Valor total
                      </Typography>
                      <Typography
                        textAlign={"center"}
                        width={"100%"}
                        fontSize={24}
                        fontWeight={600}
                        color={colors.purple[500]}
                      >
                        {item?.product?.discountPrice > 0
                          ? `${BRLmoney(
                              item?.product?.discountPrice * item?.quantity
                            )}`
                          : `${BRLmoney(
                              item?.product?.price * item?.quantity
                            )}`}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))
          ) : (
            <Typography
              m="100px 0px"
              fontSize={isMobile ? 18 : 24}
              color={colors.purple[500]}
              fontWeight={700}
            >
              Seu carrinho está vazio
            </Typography>
          )}
        </Box>
      </Box>

      <DrawerCheckout
        fullPrice={selectedProducts.reduce((acc, next) => {
          if (next?.product?.discountPrice > 0) {
            return acc + next?.product?.discountPrice * next.quantity;
          }
          return acc + next.product.price * next.quantity;
        }, 0)}
        totalItens={selectedProducts.reduce((acc, next) => {
          return acc + next.quantity;
        }, 0)}
        selectedProducts={selectedProducts}
        nextStep={setStep}
        btnText="Ir para o pagamento"
        showBackBTN={step === 2}
        addressToOrder={(adID) => setSelectedAddressID(adID)}
        selectedAddressID={selectedAddressID}
        setSelectedFrete={setSelectedFrete}
        selectedFrete={selectedFrete}
        disablePayButton={false}
      />
    </>
  );
}
